
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useNavigationType } from 'react-router';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { ProjectGet } from '../../../api/orgService';
import { toast } from 'react-toastify';
import useApi from '../../../api/useApi';
import SkeletonList from '../../sections/SkeletonList';


function ProjectAdminList() {


      const navigate = useNavigate()
      const location = useLocation()
      const [AllProjects,setAllProjects] =useState([])
      const [nextPageUrl, setNextPageUrl] = useState('http://localhost:8000/api/projects/');
      const [loading, setLoading] = useState(false);
  
      const { request: getAllProjects, data:projectData, error:projectError,isLoading:projectsLoading} = useApi(ProjectGet);
  
            useEffect(() => {
              getAllProjects();
                   // eslint-disable-next-line
              }, []);
              
              useEffect(()=>{
                if (projectData?.status===200) {
                  setAllProjects(projectData?.data);
                }
              // eslint-disable-next-line
              },[projectData])
      
            
              // useEffect(()=>{
              //     if(location?.state?.refresh==="org"){
              //       getAllProjects();
              //     }
              //   // eslint-disable-next-line
              //   },[location?.state])
            
              useEffect(()=>{
                  if(projectError){
                      toast.error(`${JSON.stringify(projectError?.response?.data,null,2)}`,{position: "top-center"});
                }
              },[projectError]) 

            const rows = [
                { id: 1, title: 'Project Test', description: 'the Community version', link: "/staff/article/detail"},
                { id: 2, title: 'Data Grid Pro', description: 'the Pro version', link: "/staff/article/detail?id=1" },
                { id: 3, title: 'Data Grid Premium', description: 'the Premium version', link: "/staff/article/detail?id=1" },
                ];
                
            const columns = [
                { field: 'id', headerName: 'SN Number', width: 200 },
                { field: 'name', headerName: 'Project Number', width: 200 },
                { field: 'location', headerName: 'Project Location', width: 300 },
                { field: 'link', headerName: 'View Details', width: 300,
                    renderCell: (params) => (
                        // <Link
                        //   href={params.value}
                        //   style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
                        // >
                        //   View details →
                        // </Link>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => 
                              navigate(`/staff/project/detail/${params.row.id}/`, {state: { projectId: params.row.id, projectName: params.row.name }})
                            
                            }
                            sx={{
                            textTransform: 'none',
                            backgroundColor: '#1976d2',
                            '&:hover': { backgroundColor: '#115293' },
                            }}
                        >
                            View Details →
                        </Button>
                        ),
                }
            
                ];
            
            if(projectsLoading){
              return (
                <SkeletonList/>
              )
            }
            return (
            <div style={{ height: '80%', width: '100%' }}>
                <DataGrid rows={AllProjects?.results} columns={columns} />
            </div>
  )
}

export default ProjectAdminList